import * as Yup from 'yup';

export const changePasswordPageValidation = Yup.object({
  currentPassword: Yup.string().required('Senha atual é obrigatória'),
  newPassword: Yup.string()
    .required('Nova senha é obrigatória')
    .min(8, 'A nova senha deve ter no mínimo 8 caracteres'),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('newPassword'), undefined], 'As senhas não coincidem')
    .required('Confirmação de senha é obrigatória'),
});
